import { $store } from '@/provider/plugin';
import { useRootStore } from '@/store/root';
import { getDefaultPath } from '@/router';

const routes = [
  {
    path: 'cockpit',
    meta: {
      public: false,
    },
    component: () => import('@/layouts/Main.vue'),
    beforeEnter: async () => {
      await $store.dispatch('dashboard/resetSelectedDashboard', {});
    },
    children: [
      {
        name: 'teams-cockpit',
        path: 'teams/:id?',
        beforeEnter: (_, from, next) => {
          if (useRootStore().getUserGroups.teamsAdmin) {
            useRootStore().parentObject = { type: 'cockpit' };
            next();
          } else {
            next(getDefaultPath('error-403'));
          }
        },
        component: () => import('@/views/cockpits/Cockpit/Cockpit.vue'),
        props: { initialTab: 1 },
      },
      {
        name: 'dashboard-cockpit',
        path: 'dashboard/:id?',
        beforeEnter: (_, from, next) => {
          if (useRootStore().getUserGroups.dashboardAdmin) {
            useRootStore().parentObject = { type: 'cockpit' };
            next();
          } else {
            next(getDefaultPath('error-403'));
          }
        },
        component: () => import('@/views/cockpits/Cockpit/Cockpit.vue'),
        props: { initialTab: 0 },
      },
    ],
  },
];

export default routes;
